import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/cn';

/**
 * Card variants using CVA (Class Variance Authority)
 * Defines all visual variations of the Card component
 */
const cardVariants = cva(
  // Base styles (always applied)
  ['rounded-linkode', 'border-2', 'p-8', 'flex flex-col', 'transition-all duration-200'],
  {
    variants: {
      highlighted: {
        true: 'bg-linkode-bg-orange border-linkode-primary',
        false: 'bg-white border-linkode-text',
      },
      hoverable: {
        true: 'hover:shadow-linkode-card hover:-translate-y-1',
        false: '',
      },
    },
    defaultVariants: {
      highlighted: false,
      hoverable: true,
    },
  }
);

/** Exported type for Card variants */
export type CardVariants = VariantProps<typeof cardVariants>;

export interface CardProps extends React.HTMLAttributes<HTMLDivElement>, CardVariants {
  /** Card content */
  children: React.ReactNode;
}

/** Card component with MotherDuck-style hover shadow */
export const Card: React.FC<CardProps> = ({
  highlighted,
  hoverable,
  className,
  children,
  ...props
}) => {
  return (
    <div className={cn(cardVariants({ highlighted, hoverable }), className)} {...props}>
      {children}
    </div>
  );
};

// Export cardVariants for external use (e.g., testing)
export { cardVariants };
